/**
 * The 3Lumpers mark: a pallet jack that has lifted a loaded pallet.
 *
 * Inline SVG rather than an <img> so it inherits `currentColor`, stays crisp at
 * any size, and costs no extra request. The same geometry lives in
 * `public/brand/*.svg` for print, invoices and the app icons — if you change
 * one, change both.
 */

const SHAPES = (color) => (
  <g transform="translate(4.5 -3.9)">
      <circle cx="15" cy="49.4" r="5.6"/>
      <path d="M15.6 43.6 L11 22.6" fill="none" stroke="{color}" strokeWidth="5" strokeLinecap="round"/>
      <path d="M11 21.6 L5.4 19.2" fill="none" stroke="{color}" strokeWidth="5" strokeLinecap="round"/>
      <rect x="14.6" y="43.4" width="37.4" height="4.4" rx="2.2"/>
      <circle cx="49.6" cy="52" r="3.2"/>
      <rect x="18" y="36.8" width="10.6" height="3.6" rx="1"/>
      <rect x="30.4" y="36.8" width="8.4" height="3.6" rx="1"/>
      <rect x="40.6" y="36.8" width="10.9" height="3.6" rx="1"/>
      <rect x="21" y="23.4" width="14.4" height="13.4" rx="1.5"/>
      <rect x="36.8" y="28.2" width="12.4" height="8.6" rx="1.5"/>
  </g>
);

export default function BrandMark({ size = 40, tile = true, className, title = '3Lumpers' }) {
  if (!tile) {
    return (
      <svg width={size} height={size} viewBox="0 0 64 64" className={className} role="img" aria-label={title}>
        {SHAPES('currentColor')}
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label={title}
      style={{ flex: `0 0 ${size}px` }}
    >
      <defs>
        <linearGradient id="3l-brand-tile" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ffb020" />
          <stop offset="1" stopColor="#d96b12" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="15" fill="url(#3l-brand-tile)" />
      <g transform="translate(7.4 7.4) scale(0.77)">{SHAPES('#17110a')}</g>
    </svg>
  );
}
